module.exports = __webpack_public_path__ + "img/Bosnia and Herzegovina.84844142.svg";